/**
 * @fileoverview Letters theme - match capital letters with colored circle borders.
 */

import { ThemeOptions } from '../../services/ThemeService.js';
import { TextCircledMatchingTheme } from '../abstract/TextCircledMatchingTheme.js';

/**
 * Letters theme (A-T) with circle borders and black text.
 */
export class LettersTheme extends TextCircledMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super('letters', 'Letters', ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T'], options);
    }
}
